<app-dashboard [dashboardName]="dashboardName" [allWidgets]="allWidgets" [defaultWidgets]="defaultWidgets"></app-dashboard>
